import React from "react"
import Container from '../../../core/controls/components/container'
import AttachmentContainer from "../../../core/json/companyInternal/Companyattachments"

const CompanyAttachmentsScreen = () => {

    return (
       <Container {...AttachmentContainer}   />
    )
}

export default CompanyAttachmentsScreen